"use client";
import { Toaster } from "burnt/web";

const ClientToaster = () => {
	return <Toaster position="bottom-center" />;
};
export default ClientToaster;
